import React from 'react';
import { Route } from 'react-router-dom';
import LayersListWrapper from '@features/map-layers-list/layers-list/LayersListWrapper';
import LayersTimeSelectors from '@features/map-layers-list/time-selector/LayersTimeSelectors';
import BreadcrumbedComponent from '@components/BreadcrumbedComponent/BreadcrumbedComponent';
import EvChargersList from '@features/ev-editor/EvChargersList';
import ChargerEdit from '@features/ev-editor/ChargerEdit';
import LazyLoadingWrapper from '@components/LazyLoadingWrapper/LazyLoadingWrapper';
import NavigateWithSearch from '@components/NavigateWithSearch/NavigateWithSearch';

const EvInfrastructureModePage = React.lazy(
    () => import('@pages/ProjectModes/EvInfrastructureModePage')
);

export const useEvInfrastructureRoutes = () => {
    return (
        <Route path="ev" element={<LazyLoadingWrapper element={<EvInfrastructureModePage />} />}>
            <Route index element={<NavigateWithSearch to="chargers" replace />} />
            <Route
                element={<BreadcrumbedComponent />}
                handle={{
                    crumb: (data: any) => ({
                        pathnamePostFix: 'chargers',
                        name: 'Chargers',
                        ...data,
                    }),
                }}
            >
                <Route path="chargers">
                    <Route index element={<EvChargersList />} />
                    <Route path="new" element={<ChargerEdit />} />
                    <Route
                        path=":chargerId/edit"
                        element={<ChargerEdit />}
                        loader={({ params }) => params}
                        handle={{ crumb: ({ chargerId }) => ({ id: chargerId }) }}
                    />
                </Route>
            </Route>
            <Route
                path="layers"
                element={
                    <LayersListWrapper>
                        <LayersTimeSelectors />
                    </LayersListWrapper>
                }
            />
        </Route>
    );
};
